$(document).ready(function () {

    var tags = "";
    var category = "";
    var sortBy = "";
    var pivot = "";
    var freshSearch = false;

    var currentQuery = new URLSearchParams(window.location.search);
    var searchTerm = currentQuery.get("q");

    $(".categoryFilter").click(function () {
        pivot = "cf";
        doSearch();
    });

    $("#tags").change(function () {
        pivot = "tags";
        doSearch();
    });

    if (document.getElementById("contentTypeFilterMobile") && window.getComputedStyle(document.getElementById("contentTypeFilterMobile")).display != "none") {
        $("#contentTypes").change(function () {
            pivot = "cf";
            doSearch();
        });
    }

    $("#sort").change(function () {
        var query = new URLSearchParams(window.location.search);
        pivot = query.get("pivot");
        doSearch();
    });

    $("#searchForm").on("submit", function () {
        freshSearch = true;
        var query = new URLSearchParams(window.location.search);
        pivot = query.get("pivot");
        doSearch();
        return false;
    });

    $("#clearTopics").click(function () {
        pivot = "tags";
        $("#tags").val("All Topics");
        doSearch();
        return false;
    });

    $(".adClose").click(function (event) {
        let sponsoredAd = event.target.closest(".sponsoredAd");
        $(sponsoredAd).removeClass("d-flex").addClass("d-none");
    });

    $("#clearCategories").click(function () {
        pivot = "cf";
        $('.categoryFilter:input:checked').removeAttr('checked');
        $("#contentTypes").val("Select a Category");
        doSearch();
        return false;
    });

    function doSearch() {

        if (document.getElementById("contentTypeFilterMobile") && window.getComputedStyle(document.getElementById("contentTypeFilterMobile")).display != "none") {
            category = $("#contentTypes").val();
        } else {
            $('.categoryFilter:input:checked').each(function () {
                category += $(this).val() + "-and-";
            });
        }

        tags = $("#tags").val();
        sortBy = $("#sort").val() == undefined ? sortBy : $("#sort").val();
        category = category.replace(/(\s*,?\s*)*$/, "").replaceAll("#", "");

        var searchWord = $("#searchBox").val();

        //Search/Init?q=t
        var url = window.location.origin
            + "/search/Init"
            + "?q="
            + searchWord;

        var cfPivot = false;
        var tagsPivot = false;

        if (freshSearch == false) {
            url += "&sort=" + sortBy;

            if (category != undefined && category != "" && category != "Select a Category") {
                url += "&cf=" + category;
                cfPivot = true;
            }

            if (tags != undefined && tags != "" && tags != "Select a Topic" && tags != "All Topics") {
                url += "&tags=" + encodeURIComponent(tags);
                tagsPivot = true;
            }

            if (pivot != undefined && pivot != "") {

                if (cfPivot && tagsPivot) {
                    url += "&pivot=" + pivot;
                } else if (cfPivot) {
                    url += "&pivot=cf";
                } else if (tagsPivot) {
                    url += "&pivot=tags";
                }

            }
        }

        window.location.replace(url);
    }

    $("input#searchBox").autocomplete({
        source: function (request, response) {

            sortBy = $("#sort").val() == undefined ? sortBy : $("#sort").val();

            $.ajax({
                url: window.location.origin + "/search/AutoComplete",

                data: {
                    q: request.term,
                    sort: sortBy
                },
                success: function (data) {
                    var itemArray = new Array();

                    var results = data.results;

                    for (i = 0; i < results.length; i++) {

                        itemArray[i] = {
                            label: results[i].document.title + " - " + results[i].document.category,
                            value: results[i].document.title,
                            data: results[i]
                        }
                    }

                    console.log(itemArray);
                    response(itemArray);
                },
                error: function (data, type) {
                    console.log(type);
                }
            });
        },
        select: function (event, ui) {

            sortBy = $("#sort").val() == undefined ? sortBy : $("#sort").val();

            var url = window.location.origin
                + "/search/Init"
                + "?q="
                + ui.item.data.document.title
                + "&sort="
                + sortBy;

            window.location.replace(url);
        }
    });

    $(".search-result").mousedown(function (event) {
        logSearchResultClick(searchTerm,
            $(this).attr("data-documentId"),
            $(this).attr("data-position"),
            $(this).attr("data-title"),
            $(this).attr("data-category"));
    });

    function logSearchResultClick(searchWord, documentId, position, title, category) {

        var url = window.location.origin + "/search/TrackSearchResultActivity"
            + "?searchWord=" + searchWord
            + "&documentId=" + documentId
            + "&position=" + position
            + "&title=" + title
            + "&category=" + category;

        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            headers: {
                RequestVerificationToken:
                    $('input:hidden[name="__RequestVerificationToken"]').val()
            },
            success: function () {
            },
            error: function () {
            }
        });
    }

    $(".sponsoredAd a").mousedown(function (event) {
        logSponsoredAdClick(searchTerm,
            $(this).attr("aria-label"),
            $(this).attr("href"),
            $(this).attr("data-documentId"),
            $(this).attr("data-position"));
    });

    function logSponsoredAdClick(searchWord, vendorName, vendorLink, documentId, position) {

        var url = window.location.origin + "/search/TrackSponsoredAdActivity"
            + "?searchWord=" + searchWord
            + "&vendorName=" + vendorName
            + "&vendorLink=" + vendorLink
            + "&documentId=" + documentId
            + "&position=" + position;

        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            headers: {
                RequestVerificationToken:
                    $('input:hidden[name="__RequestVerificationToken"]').val()
            },
            success: function () {
            },
            error: function () {
            }
        });
    }
});